<script>
import i18n from "@/i18n";
import {mapActions, mapState} from "pinia";
import {shareStore} from "@/store/shareStore";
import Dialog from "primevue/dialog";
import Toast from "primevue/toast";

export default {
  name: "ShareModal",
  components: {
    Dialog,
    Toast
  },
  computed: {
    ...mapState(shareStore, [
      'shareModalState',
    ]),
    modalState: {
      get() {
        return this.shareModalState;
      },
      set() {
        this.closeModal();
      },
    },
  },
  methods: {
    ...mapActions(shareStore,[
      "getShareUrl",
      "toggleShareModal",
      "setShareEntityType"
    ]),
    copyShareUrl() {
      const shareUrlInput = document.getElementById("shareUrlInput");
      shareUrlInput.focus();
      shareUrlInput.select();
      this.$toast.add({
        severity: 'info',
        summary: i18n.global.t('share.info'),
        detail: i18n.global.t('share.linkCopied'),
        life: 3000
      });
      navigator.clipboard.writeText(this.getShareUrl());
    },
    share(shareTarget) {
      let sharedUrl = '';

      if (shareTarget === 'FACEBOOK') {
        sharedUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.getShareUrl()}`;
      } else if (shareTarget === 'X') {
        sharedUrl = `https://x.com/intent/post?url=${this.getShareUrl()}`
      }

      window.open(sharedUrl, '_blank');
    },
    closeModal() {
      this.setShareEntityType(null);
      this.toggleShareModal();
    },
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          class="share-modal"
          modal
          :header="$t('share.share')"
  >
    <div>
      <div class="share-icons-section">
        <div class="share-icon share-icon--fb" @click="share('FACEBOOK')"></div>
        <div class="share-icon share-icon--tw" @click="share('X')"></div>
      </div>
      <div class="share-url-section">
        <input type="text" :value="getShareUrl()" id="shareUrlInput" readonly class="share-url-input">
        <button type="button" class="share-url-btn" @click="copyShareUrl">{{$t('share.copy')}}</button>
      </div>
      <Toast class="info-toast"/>
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.cancel')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.share-modal {
  min-width: 500px;
  .p-dialog-content {
    padding: 20px;
    line-height: 16px;
  }

  .share-icons-section {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    cursor: pointer;

    .share-icon {
      width: 50px;
      height: 50px;
      border-radius: 50px;
      background-size: 100%;

      &--fb {
        background-image: url("~@/assets/img/share/icons8-facebook-circled-96.svg");
      }
      &--tw {
        background-image: url("~@/assets/img/share/Twitter-X-Icon.svg");
        background-size: 74px;
        background-position: center;
      }
    }
  }

  .share-url-section {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #d1d1d1;
    border-radius: 5px;

    .share-url-input {
      width: 100%;
      margin-right: 20px;
    }
    .share-url-btn {
      height: 32px;
      padding: 0 15px;
      background: #7130a0;
      font-family: "Open Sans", Arial, sans-serif;
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
      color: #fff;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}

.info-toast {
  .p-toast-message {
    background: #fff;
    color: #7130a0;
    margin-left: 0;
    border: 1px solid #7130a0;
    border-radius: 6px;
    .p-toast-detail {
      color: #7130a0;
    }
    .p-toast-close-button {
      &:hover {
        background: transparent;
      }
    }
  }

}

</style>